module.exports = __webpack_public_path__ + "static/media/add-inside-circle.f38eea56.svg";